// extracted by mini-css-extract-plugin
export default {"ChatContainer":"chatlayout_ChatContainer__lxkuF"};